import { isNumber } from 'util';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_65 implements Validator {

    public static id = 'CTRL_65';
    private message = 'error.ctr_65';


    public LOG: LogService = new LogService(CTRL_65);


    validate(form: any, map) {


        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_65.id + '_');


        if (rgs.length > 0) {
            for (const rg of rgs) {
                const ctrl = form.controls[rg];
                if (!ctrl || !ctrl.value || !ctrl.value.rgCtrls) {
                    continue;
                }
                const firstWithStepId = map.get(ctrl.value.rgCtrls.firstChamp);
                const firstCtrl = form.controls[firstWithStepId];

                // Récupérer la valeur de manière sécurisée
                let valueStr = '';
                if (firstCtrl && firstCtrl.value != null) {
                    valueStr = typeof firstCtrl.value === 'string' ? firstCtrl.value : '';
                }

                // Si le champ est vide, pas d'erreur (comportement original)
                if (valueStr.length === 0) {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                    continue;
                }

                const trimmedLength = valueStr.replace(/\s/g, '').length;

                if (trimmedLength < 5 || !valueStr.match(/[0-9A-Za-z]/g)) {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
            }
        }
    }
}
